import { render, staticRenderFns } from "./RequestKp.vue?vue&type=template&id=726c1900&scoped=true&"
import script from "./RequestKp.vue?vue&type=script&lang=js&"
export * from "./RequestKp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c1900",
  null
  
)

export default component.exports